var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fc6;}.cls-2{fill:#ffba55;}.cls-3{fill:#dad7e5;}.cls-4{fill:#edebf2;}.cls-5{fill:#ffde76;}.cls-6{fill:#c6c3d8;}.cls-7{fill:#82bcf4;}.cls-8{fill:#db5669;}.cls-9{fill:#f26674;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Email report") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email_report",
    "data-name": "Email report"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,32,2.17,45.83A4,4,0,0,1,1,43V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.83,45.83A4,4,0,0,1,43,47H5a4,4,0,0,1-2.83-1.17L19.76,28.24a6,6,0,0,1,8.48,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,17c0,27.14.44,27.16-1.17,28.83L32,32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7 11 7 23 1 17 7 11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "47 17 41 23 41 11 47 17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41,1V23l-9,9c-3.65-3.65-4.86-5.51-8-5.51S19.6,28.4,16,32L7,23V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41,1V20.17l-9,9c-2.55-2.54-4.17-4.68-8-4.68s-5.5,2.19-8,4.68l-6-6V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45,45H8a4,4,0,0,1-3.28-1.72l15-15a6,6,0,0,1,8.48,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16,32,4.72,43.28C3.69,41.79,4,42.33,4,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47,17c0,30.63.68,28-2,28L32,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M31,19H27a1,1,0,0,1,0-2h4A1,1,0,0,1,31,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M37,15H27a1,1,0,0,1,0-2H37A1,1,0,0,1,37,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M37,11H27a1,1,0,0,1,0-2H37A1,1,0,0,1,37,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,8v6l-4.24,4.24A6,6,0,0,1,17,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M23,14H17V8A6,6,0,0,1,23,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M23,14a6,6,0,0,1-10.24,4.24L17,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M23,14a5.91,5.91,0,0,1-.88,3.12,6,6,0,0,1-7.36-.88L17,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M17,8v6l-2.24,2.24a6,6,0,0,1-.88-7.36A5.91,5.91,0,0,1,17,8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.3ea8aa2db7e7b78a017bc0cee1bede6f.svg";
export { ForwardRef as ReactComponent };